import React from 'react'

export const EmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-2 px-4">
      <div className="px-4 flex-col flex items-start justify-start pb-4">
        <div className="text-lg font-bold text-gray-900 text-start mb-2">No JPE programs match your search criteria</div>
        <div className="text-sm text-gray-600">Please adjust your filters and try again.</div>
      </div>
      <div>
        <img src="/images/reservation_lp/consultation.webp" alt="No results found" className="w-full h-auto object-contain" />
      </div>
    </div>
  )
}
